module.exports = __webpack_public_path__ + "static/media/customerFeel-excited.81cad6e3.jpg";